import { useEffect, useState } from 'react';
import CISection from './CISection';
import MainSwiperSection from './MainSwiperSection';
import Section01 from './Section01';
import Section02 from './Section02';
import Section03 from './Section03';
import Section04 from './Section04';
import Section05 from './Section05';
import MCarsayoGiftPopup from './MCarsayoGiftPopup';
import MobileJijelModal from '../shared/m/modal/jijelModal';

interface MainContentProps {
  sectionRefs: {
    section1: React.RefObject<HTMLDivElement>;
    section2: React.RefObject<HTMLDivElement>;
    section3: React.RefObject<HTMLDivElement>;
    sectionCI: React.RefObject<HTMLDivElement>;
    section4: React.RefObject<HTMLDivElement>;
  };
  scrollToSection: (section: string) => void;
}

const M_MainPage = ({ sectionRefs, scrollToSection }: MainContentProps) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    const popupLocalStorage = localStorage.getItem('mPopupTodayHidden');

    if (!popupLocalStorage) {
      setIsPopupOpen(true);
      return;
    }

    if (Date.now() > Number(popupLocalStorage)) {
      localStorage.removeItem('mPopupTodayHidden');
      setIsPopupOpen(true);
    } else {
      setIsPopupOpen(false);
    }
  }, []);
  return (
    <div>
      {/* <MainSwiperSection scrollToSection={scrollToSection} /> */}
      {/* <Section01 scrollToSection={scrollToSection} /> */}
      <section className='w-full'>
        <div className='w-full pt-[40px] px-[20px] pb-[10px]'>
          <p className='text-[#1C1F35] text-[16px] leading-[25.6px] font-[600] mb-[30px]'>
            The Federation of
            <br />
            Korean Sales and Business
          </p>
          <ul className='w-full flex flex-col justify-start items-start gap-[12px]'>
            <li className='overflow-hidden w-full rounded-[10px]'>
              <img
                src='/imgs/section0_bg01.webp'
                alt='배경이미지1'
                className='w-full  min-h-[200px] object-cover'
              />
            </li>
            <li className='overflow-hidden w-full rounded-[10px]'>
              <img
                src='/imgs/section0_bg02.webp'
                alt='배경이미지2'
                className='w-full  min-h-[200px] object-cover'
              />
            </li>
          </ul>
        </div>
      </section>
      <Section02 contentsRef={sectionRefs.section1} />
      <Section03 contentsRef={sectionRefs.section2} />
      <Section04 contentsRef={sectionRefs.section3} />
      <CISection contentsRef={sectionRefs.sectionCI} />
      <Section05 contentsRef={sectionRefs.section4} />
      {/* <MCarsayoGiftPopup isOpen={isPopupOpen} setIsOpen={setIsPopupOpen} /> */}
      <MobileJijelModal />
    </div>
  );
};
export default M_MainPage;
